// libs
import React, { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

//selectors
import { getAppliedFilters } from 'shared/store/listingV2/selectors';

//hooks
import { useFilters } from 'shared/store/listingV2/hooks';

//components
import ResetIcon from '@nykaa/ui-components/Icons/reset';
import ResetOverlaySheet from 'shared/components/Filter/components/ResetOverlaySheet';

//styles
import { Button } from './styles';

// analytics
import { onClearFilters } from 'shared/layouts/Listing/components/Analytics/helpers';

const RESET = 'Reset';

function ResetButton() {
  const [showResetSheet, setShowResetSheet] = useState(false);
  const appliedValues = useSelector(getAppliedFilters);
  const { sort, ...otherFilters } = appliedValues;
  const { updateAppliedFilter } = useFilters();

  const onResetClick = () => {
    const appliedFilters: Record<string, string> = {};
    if (sort) appliedFilters.sort = sort;
    updateAppliedFilter(appliedFilters);
    onClearFilters();
  };

  const onResetButtonClick = () => {
    if (!isEmpty(otherFilters)) setShowResetSheet(true);
  };

  const onHide = () => {
    setShowResetSheet(false);
  };

  return (
    <>
      <Button
        kind="secondary"
        shape="default"
        size="medium"
        onClick={onResetButtonClick}
        trailingIcon={<ResetIcon />}
        disabled={isEmpty(otherFilters)}
      >
        {RESET}
      </Button>
      {showResetSheet && <ResetOverlaySheet onHide={onHide} onResetClick={onResetClick} />}
    </>
  );
}

export default memo(ResetButton);
